import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ClickCorrelationService {
  private readonly pendingMap = signal<Map<string, true>>(new Map());
  readonly lastCompletedId = signal<string | null>(null);

  register(id: string): void {
    this.pendingMap.update((m) => new Map([...m, [id, true]]));
  }

  claimNext(): string | null {
    const map = this.pendingMap();
    const id = map.keys().next().value ?? null;
    if (!id) return null;
    this.pendingMap.update((m) => {
      const n = new Map(m);
      n.delete(id);
      return n;
    });
    return id;
  }

  remove(id: string): void {
    this.pendingMap.update((m) => {
      const n = new Map(m);
      n.delete(id);
      return n;
    });
  }

  isPending(id: string): boolean {
    return this.pendingMap().has(id);
  }

  markComplete(id: string): void {
    this.lastCompletedId.set(id);
  }

  clearLastCompleted(): void {
    this.lastCompletedId.set(null);
  }
}
